import { LandingPageData, TrendingAsset, OrderbookStats, OrderbookLatestResponse, DiscountedAssetsResponse } from '@/types/main'
import { BaseService } from './api'

class MainScreenService extends BaseService {
  async getLandingPageData(params?: Record<string, any>): Promise<LandingPageData> {
    try {
      const [trending, stats, orders, discounted] = await Promise.all([
        this.get<{ data: TrendingAsset[] }>('/orderbook/trending'),
        this.get<OrderbookStats>('/orderbook/stats'),
        this.get<OrderbookLatestResponse>('/orderbook', { params }),
        this.get<DiscountedAssetsResponse>('/orderbook/discounted').catch((err) => {
          console.warn('Failed to fetch discounted assets:', err)
          return { total: 0, page: 1, items: 0, data: [] } as DiscountedAssetsResponse
        }),
      ])

      return {
        trendingAssets: trending.data || [],
        orderbookStats: stats,
        latestOrders: orders.data || [],
        discountedAssets: discounted?.data || []
      }
    } catch (error) {
      console.error('Error fetching landing page data:', error)
      throw new Error('Failed to load landing page data')
    }
  }
}

export const mainScreenService = new MainScreenService() 